import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import clientService from "./clientService";

export const getClients = createAsyncThunk("client/get-clients", async (thunkAPI) => {
  try {
    return await clientService.getClients();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createClient = createAsyncThunk("client/create-client", async (clientData, thunkAPI) => {
  try {
    return await clientService.createClient(clientData);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getAClient = createAsyncThunk("client/get-client", async (id, thunkAPI) => {
  try {
    return await clientService.getClient(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

 

// thunk
export const updateAClient = createAsyncThunk(
  "client/update-client",
  async ({ id, clientData }, thunkAPI) => {
    try {
      return await clientService.updateClient({ id, clientData }); // pass id
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);



export const deleteAClient = createAsyncThunk("client/delete-client", async (slug, thunkAPI) => {
  try {
    return await clientService.deleteClient(slug);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const resetState = createAction("client/reset");

const initialState = {
  clients: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const clientSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClients.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.clients = action.payload;
      })
      .addCase(getClients.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(createClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.createdClient = action.payload;
      })
      .addCase(createClient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(getAClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.clientTitle = action.payload.title;
        state.clientImages = action.payload.images;
      })
      .addCase(getAClient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(updateAClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.updatedClient = action.payload;
      })
      .addCase(updateAClient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(deleteAClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.deletedClient = action.payload;
      })
      .addCase(deleteAClient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(resetState, () => initialState);
  },
});

export default clientSlice.reducer;
